// src/components/ResourceManager/Hardware/HardwareTableColumns.ts

import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { Partner } from "../request/request";


// Icons
import { ReactComponent as IconEye } from "../../../../../shared/assets/Icons/Icon_Eye.svg";
import { ReactComponent as IconEdit } from "../../../../../shared/assets/Icons/Icon_Edit.svg";
import { ReactComponent as IconDelete } from "../../../../../shared/assets/Icons/Icon_Delete.svg";


/**
 * Props que recibe getHardwareColumns para definir las acciones.
 */
interface PartnerColumnsProps {
    handleViewPartner: (hw: Partner) => void;
    handleEditPartner: (hw: Partner) => void;
    handleDeleteClick: (hw: Partner) => void;
}

/**
 * Retorna las columnas de la tabla para Hardware.
 */
export function getPartnerColumns({
    handleViewPartner,
    handleEditPartner,
    handleDeleteClick,
}: PartnerColumnsProps): GenericTableColumn<Partner>[] {
    return [
        {
            header: "ID",
            accessor: "id",
        },
        {
            header: "Partner Name",
            accessor: "displayName",
        },
        {
            header: "Domain",
            accessor: "domain",
        },
        {
            header: "Product list",
            accessor: "productList",
        },
        {
            header: "Actions",
            accessor: "id",
            renderCell: (row) => (
                <div className="flex items-center gap-2">
                    {/* View */}
                    <button
                        className="
              flex items-center justify-center
              border border-semantic-border-secondary
              rounded
              text-semantic-text-secondary
              hover:bg-semantic-state-active
              w-10 h-10
            "
                        onClick={() => handleViewPartner(row)}
                    >
                        <IconEye className="w-6 h-6" />
                    </button>

                    {/* Edit */}
                    <button
                        className="
              flex items-center justify-center
              border border-semantic-border-secondary
              rounded
              text-semantic-text-secondary
              hover:bg-semantic-state-active
              w-10 h-10
            "
                        onClick={() => handleEditPartner(row)}
                    >
                        <IconEdit className="w-10 h-10" />
                    </button>

                    {/* Delete */}
                    <button
                        className="
              p-2
              border border-semantic-border-secondary
              rounded
              bg-red-50
              text-red-600
              hover:bg-red-100
            "
                        onClick={() => handleDeleteClick(row)}
                    >
                        <IconDelete className="w-6 h-6" />
                    </button>
                </div>
            ),
        },
    ];
}
